import { FunctionComponent } from "react";
import Button from "./Button";
import { HiOutlineArrowRight } from "react-icons/hi";
import usePersistedEnvironmentState from "../src/usePersistedEnvironmentState";
import useTenant from "../src/useTenant";

const GetStartedCta: FunctionComponent = () => {
  const [hasCompletedGetStartedFlow] = usePersistedEnvironmentState(
    "has_completed_get_started_flow"
  );
  const { tenant } = useTenant();

  // Don't show the CTA to anyone who has completed it or is already a customer
  if (hasCompletedGetStartedFlow || tenant?.kind === "production") {
    return null;
  }
  return (
    <div className="flex justify-center mt-4">
      <Button href="/get-started" theme="primary">
        <div className="flex space-x-2 items-center">
          <div>Get Started with Oso Cloud</div>
          <div>
            <HiOutlineArrowRight />
          </div>
        </div>
      </Button>
    </div>
  );
};

export default GetStartedCta;
